module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "text-center",
    attrs: {
      "id": "mass-unsuspend"
    }
  }, [_c('h3', [_vm._v("You are about to mass-unsuspend the below tariffs")]), _vm._v(" "), (!_vm.confirming) ? _c('div', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.confirming = true
      }
    }
  }, [_vm._v("\n    Confirm mass-unsuspension\n  ")]) : _vm._e(), _vm._v(" "), (_vm.confirming) ? _c('div', [_c('h5', [_vm._v("\n      Are you sure?\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.update
    }
  }, [_vm._v("\n      Confirm\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "btn btn-danger",
    on: {
      "click": function($event) {
        _vm.confirming = false
      }
    }
  }, [_vm._v("\n      Cancel\n    ")])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9c4186b0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/admin/components/Tariff/MassUnsuspend.vue
// module id = 2259
// module chunks = 1